import React, { useState, useRef, useEffect } from 'react';
import './SearchableDropdown.scss';
import SearchIcon from 'src/assets/icons/searchlogo.svg';

interface Option {
  label: string;
  value: string;
}

interface Props {
  options: Option[];
  placeholder?: string;
  onSelect: (option: Option) => void;
  value: string;
  onInputChange: (value: string) => void;
}

const SearchableDropdown: React.FC<Props> = ({
  options,
  placeholder = 'Search...',
  onSelect,
  value,
  onInputChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const filteredOptions = options.filter(opt =>
    opt.label.toLowerCase().includes(value.toLowerCase()),
  );

  const handleSelect = (option: Option) => {
    setIsOpen(false);
    onSelect(option);
  };

  return (
    <div className="searchable-dropdown" ref={dropdownRef}>
      <div className="search-label text-start">Search Insurance Name</div>

      <div
        className="search-input-wrapper d-flex align-items-center"
        onClick={() => {
          setIsOpen(true);
          inputRef.current?.focus();
        }}
      >
        <img src={SearchIcon} alt="SearchIcon" className="search-icon ms-3" />

        <input
          ref={inputRef}
          type="text"
          className="searchable-dropdown-input"
          placeholder={placeholder}
          value={value}
          onChange={e => {
            onInputChange(e.target.value);
            setIsOpen(true);
          }}
          onFocus={() => setIsOpen(true)}
        />
      </div>

      {isOpen && (
        <div className="searchable-dropdown-list">
          {filteredOptions.length > 0 ? (
            filteredOptions.map(option => (
              <div
                key={option.value}
                className="searchable-dropdown-item"
                onClick={() => handleSelect(option)}
              >
                {option.label}
              </div>
            ))
          ) : (
            <div className="searchable-dropdown-empty">No results found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchableDropdown;
